import { useEffect, useState } from 'react'
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition'

import checkPronunciation from './pronunciation-algo'

let timerId

const useRecognition = ({
  target_text,
  language,
  difficulty = 'normal',
  delay = 500,
  onMarkCorrect = () => {},
  onMarkIncorrect = () => {},
}) => {
  const {
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
    isMicrophoneAvailable,
    transcript,
    // interimTranscript: transcript,
  } = useSpeechRecognition()

  const [isCorrect, setIsCorrect] = useState(false)

  useEffect(() => {
    if (transcript && !isCorrect && listening) {
      clearTimeout(timerId)
      timerId = setTimeout(() => {
        CheckPronunciation()
      }, delay)
    }

    return () => {
      clearTimeout(timerId)
    }
  }, [transcript, listening])

  useEffect(() => {
    stopListening()
    if (transcript) resetTranscript()
  }, [target_text])

  const CheckPronunciation = () => {
    const correct = checkPronunciation(transcript, target_text, difficulty, language)

    if (correct) {
      setIsCorrect(true)
      delayedResetTranscript()
      onMarkCorrect()
    } else if (transcript?.length > target_text?.length) {
      // reset the transcript if the transcript is longer than the target_text
      setIsCorrect(false)
      delayedResetTranscript()
      onMarkIncorrect()
    }
  }
  const delayedResetTranscript = () => {
    setTimeout(() => {
      setIsCorrect(false)

      resetTranscript()
    }, 1000)
  }

  const startListening = () => {
    SpeechRecognition.startListening({
      continuous: true,
      language,
    })
  }
  const stopListening = () => {
    SpeechRecognition.stopListening()
    SpeechRecognition.abortListening()
  }

  return {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
    startListening,
    stopListening,
    isCorrect,
    isMicrophoneAvailable,
  }
}

export default useRecognition
